import moment from 'moment';
import { isIOS, isMacOs, isMobile, isTablet } from 'react-device-detect';
import tinycolor from 'tinycolor2';

import { qplayerDomain, qplayerLoaderUrl } from './config';

export const ENTERPRISE_CONFIG_ID = 'Enterprise';
export const STORY_CONFIG_ID = 'Story';
export const SCENE_EDITOR_PLAYER_CONFIG_ID = '847a7a05-52c8-4495-bf26-5cae9eea2f86';
export const SCENE_EDITOR_PLAYER_ACCOUNT_ID = 'Accpy7KNHj1IUilFL5BMuNL0Q';
export const EDITOR_PLAYER_ID = 'player-for-editor';

export const SCREEN_TYPE = {
	huge: 'huge',
	big: 'big',
	medium: 'medium',
	small: 'small',
	mobile: 'mobile',
};
export const FONTS = ['Arial', 'Poppins', 'Roboto'];

export const getTime = (input) => {
	let timeArray = input.split(':');
	return {
		hours: timeArray[0],
		minutes: timeArray[1],
		seconds: timeArray.length > 2 ? timeArray[2] : '00',
		milliseconds: timeArray.length > 3 ? timeArray[3] : '000',
	};
};

export const returnAddedTime = (time, duration, format) => {
	let newTime = new Date(moment(time).add(duration, format));
	return newTime;
};

export const getTimelineStartDate = (_) => {
	//date changed to 1970 as when page is opened in one date and try to save in another date values are saved in negative numbers
	let d = new Date(0);
	d.setHours(0);
	return d;
};

export const getTimelineTimeFromTimeInput = (input) => {
	const timeInput = (input ?? '00:00:00:00').replace('.', ':');
	let time = getTime(timeInput);
	let newTime = getTimelineStartDate();
	newTime.setHours(time.hours);
	newTime.setMinutes(time.minutes);
	newTime.setSeconds(time.seconds);
	newTime.setMilliseconds(time.milliseconds.substr(0, 3));
	return newTime;
};

export const getSecondsFromTimelineTime = (time) => {
	return Number(getTimeDifferenceInSeconds(time, getTimelineStartDate()));
};

export const getTimeDifferenceInSeconds = (afterTime, beforeTime) => {
	if (!afterTime || !beforeTime) {
		return null;
	}
	return (new Date(afterTime).getTime() - new Date(beforeTime).getTime()) / 1000;
};

export const getDifferenceBetweenTwodates = (endTime, startTime) => {
	let time = new Date(endTime) - new Date(startTime);
	let seconds = moment.duration(time).seconds();
	let minutes = moment.duration(time).minutes();
	let hours = moment.duration(time).hours();
	let days = moment.duration(time).days();
	let str = '';
	if (days > 0) {
		hours = days * 24 + hours;
	}
	str = str + (hours > 9 ? hours : '0' + hours) + ':' + (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds);
	return str;
};

export const joinClassNames = (...args) => {
	if (!args) {
		return '';
	}

	let classNames = '';
	if (args.length === 1 && typeof args[0] === 'string') {
		const classes = args[0].split(' ').filter(Boolean);
		classNames = classes.length > 0 ? classes.join(' ').trim() : '';
	} else {
		for (const arg of args) {
			if (!arg) {
				classNames = classNames;
			} else if (typeof arg === 'string') {
				classNames += ' ' + arg.trim();
			} else if (typeof arg === 'object' && arg.length) {
				for (const a of arg) {
					classNames += ' ' + joinClassNames(a);
				}
			}
		}
	}

	return classNames.trim();
};

export const toHHMMSS = (time, minus = false) => {
	if (!time && time !== 0) {
		return '--:--';
	} else {
		const timing = time;

		var hours = Math.floor(timing / 3600);
		var minutes = Math.floor(timing / 60) % 60;
		var seconds = Math.floor(timing % 60);

		if (hours < 10) {
			hours = '0' + hours;
		}
		if (minutes < 10) {
			minutes = '0' + minutes;
		}
		if (seconds < 10) {
			seconds = '0' + seconds;
		}

		const sign = minus ? '-' : '';
		if (hours === '00') {
			return sign + minutes + ':' + seconds;
		} else {
			return sign + hours + ':' + minutes + ':' + seconds;
		}
	}
};

export const heartAnimation = (controlBarClassName) => {
	var b = Math.floor(Math.random() * 100 + 1);
	var d = ['flowOne', 'flowTwo', 'flowThree'];
	var a = ['colOne', 'colTwo', 'colThree', 'colFour', 'colFive', 'colSix'];
	var c = (Math.random() * (1.6 - 1.2) + 1.2).toFixed(1);

	const heartIcon = document.createElement('i');
	heartIcon.className = 'fa fa-heart';
	const heart = document.createElement('div');
	heart.className = 'heart part-' + b + ' ' + a[Math.floor(Math.random() * 6)];
	heart.style.width = '15px';
	heart.style.height = '15px';
	heart.style.fontSize = Math.floor(Math.random() * (50 - 22) + 22) + 'px';
	heart.style.animation = d[Math.floor(Math.random() * 3)] + ' ' + c + 's linear';
	heart.appendChild(heartIcon);

	const heartControlBar = document.getElementsByClassName(controlBarClassName)[0];
	if (heartControlBar) {
		heartControlBar.appendChild(heart);
	}

	const parts = document.getElementsByClassName('part-' + b);
	if (parts && parts.length > 0) {
		for (const p of parts) {
			if (!p) {
				return;
			}
			p.style.display = 'block';
			setTimeout(() => {
				p.style.display = 'none';
				heartControlBar.removeChild(p);
			}, c * 900);
		}
	}
};

export const setAdditionalStyleSheet = ({ settings, isMediaLive, paramSharing, paramDownload }) => {
	if (!settings) {
		return;
	}

	if (!document.getElementById('sheetSubtitleStyling')) {
		let sheetSubtitleStyling = document.createElement('style');
		sheetSubtitleStyling.id = 'sheetSubtitleStyling';
		const subBottom = !settings?.subtitleStyling?.position?.y ? '10px' : `${settings?.subtitleStyling?.position?.y}%`;
		const isIOS183 = isIOS && (navigator.userAgent.includes('18.3') || navigator.userAgent.includes('18_3'));
		const isIOS182 = isIOS && (navigator.userAgent.includes('18.2') || navigator.userAgent.includes('18_2'));
		const additional =
			isIOS183 || isIOS182
				? `.gobrain-id-mediaplayer-container *::-webkit-media-text-track-container {
			padding: 0px !important;
			transform: translateY(20%) !important;
		}`
				: '';
		const subtitleStyling = `div[data-internal-gobrain-box-configuration-modulename='Subtitles'] {bottom: ${subBottom} !important;} ${additional}`;

		sheetSubtitleStyling.innerHTML = subtitleStyling;
		document.head.appendChild(sheetSubtitleStyling);
	}

	if (isMediaLive && !document.getElementById('sheetLivePLayer')) {
		var sheetLivePLayer = document.createElement('style');
		sheetLivePLayer.id = 'sheetLivePLayer';
		sheetLivePLayer.innerHTML =
			'.gobrain-time-position{display: none !important;} .gobrain-fn-backward{display: none !important;} .gobrain-fn-forward{display: none !important;}';
		document.head.appendChild(sheetLivePLayer);
	}

	if (!settings?.bottomControls?.enabled && !document.getElementById('sheetHideControlBar')) {
		var sheetHideControlBar = document.createElement('style');
		sheetHideControlBar.id = 'sheetHideControlBar';
		sheetHideControlBar.innerHTML = '.gobrain-id-controls-container{display: none !important;}';
		document.head.appendChild(sheetHideControlBar);
	}

	if (!settings?.bottomControls?.showRewindForwardButtons && !document.getElementById('sheetHideRewindForwardButtons')) {
		var sheetHideRewindForwardButtons = document.createElement('style');
		sheetHideRewindForwardButtons.id = 'sheetHideRewindForwardButtons';
		sheetHideRewindForwardButtons.innerHTML =
			'.gobrain-controller-backward{display: none !important;} .gobrain-controller-forward{display: none !important;}';
		document.head.appendChild(sheetHideRewindForwardButtons);
	}

	if (!settings?.bottomControls?.showTimeline && !document.getElementById('sheetHideTimeline')) {
		var sheetHideTimeline = document.createElement('style');
		sheetHideTimeline.id = 'sheetHideTimeline';
		sheetHideTimeline.innerHTML = '.gobrain-id-controls-container .gobrain-progress-wrapper{display: none !important;}';
		document.head.appendChild(sheetHideTimeline);
	}

	if (!settings?.bottomControls?.showPlaybackControls && !document.getElementById('sheetHidePlaybackControls')) {
		var sheetHidePlaybackControls = document.createElement('style');
		sheetHidePlaybackControls.id = 'sheetHidePlaybackControls';
		sheetHidePlaybackControls.innerHTML = '.gobrain-video-left{visibility: hidden !important;}';
		document.head.appendChild(sheetHidePlaybackControls);
	}

	if (!settings?.bottomControls?.showSettingsButton && !document.getElementById('sheetHideSettingsButton')) {
		var sheetHideSettingsButton = document.createElement('style');
		sheetHideSettingsButton.id = 'sheetHideSettingsButton';
		sheetHideSettingsButton.innerHTML = '.gobrain-controller-additional-settings{ display: none !important;}';
		document.head.appendChild(sheetHideSettingsButton);
	}

	if (!settings?.bottomControls?.showVideoQualitySettings && !document.getElementById('sheetHideVideoQualitySettings')) {
		var sheetHideVideoQualitySettings = document.createElement('style');
		sheetHideVideoQualitySettings.id = 'sheetHideVideoQualitySettings';
		sheetHideVideoQualitySettings.innerHTML = '.gobrain-option-quality{ display: none !important;}';
		document.head.appendChild(sheetHideVideoQualitySettings);
	}

	if (!settings?.bottomControls?.showAudioControls && !document.getElementById('sheetHideAudioControls')) {
		var sheetHideAudioControls = document.createElement('style');
		sheetHideAudioControls.id = 'sheetHideAudioControls';
		sheetHideAudioControls.innerHTML = '.gobrain-controller-volume{ display: none !important;}';
		document.head.appendChild(sheetHideAudioControls);
	}

	if (!settings?.bottomControls?.showFullscreen && !document.getElementById('sheetHideFullscreen')) {
		var sheetHideFullscreen = document.createElement('style');
		sheetHideFullscreen.id = 'sheetHideFullscreen';
		sheetHideFullscreen.innerHTML = '.custom-fullscreen-player{ display: none !important;}';
		document.head.appendChild(sheetHideFullscreen);
	}

	if (!settings?.bottomControls?.showPlayPauseButton && !document.getElementById('sheetHidePlayPauseButton')) {
		var sheetHidePlayPauseButton = document.createElement('style');
		sheetHidePlayPauseButton.id = 'sheetHidePlayPauseButton';
		sheetHidePlayPauseButton.innerHTML = '.gobrain-controller-play{ display: none !important;} .gobrain-fn-pause {display: none !important;}';
		document.head.appendChild(sheetHidePlayPauseButton);
	}

	if (!settings?.bottomControls?.showPictureInPicture && !document.getElementById('sheetHidePictureInPicture')) {
		var sheetHidePictureInPicture = document.createElement('style');
		sheetHidePictureInPicture.id = 'sheetHidePictureInPicture';
		sheetHidePictureInPicture.innerHTML = '.gobrain-tooltip-qbrick-player{display: none !important;}';
		document.head.appendChild(sheetHidePictureInPicture);
	}

	if (!settings?.bottomControls?.showLanguageSettingsButton && !document.getElementById('sheetHidePictureInPicture')) {
		var sheetHideLanguageSettingsButton = document.createElement('style');
		sheetHideLanguageSettingsButton.id = 'sheetHideLanguageSettingsButton';
		sheetHideLanguageSettingsButton.innerHTML = '.gobrain-fn-subtitles-and-audio{display: none !important;}';
		document.head.appendChild(sheetHideLanguageSettingsButton);
	}

	if (settings?.bottomControls?.alwaysVisible && !document.getElementById('sheetAlwaysVisisbleControlBar')) {
		var sheetAlwaysVisisbleControlBar = document.createElement('style');
		sheetAlwaysVisisbleControlBar.id = 'sheetAlwaysVisisbleControlBar';
		sheetAlwaysVisisbleControlBar.innerHTML = '.gobrain-controlbar-wrapper {opacity: 1 !important;}';
		document.head.appendChild(sheetAlwaysVisisbleControlBar);
	}

	if (!settings?.bottomControls?.showSubtitlesSettings && !document.getElementById('sheetHideSubtitlesSettings')) {
		var sheetHideSubtitlesSettings = document.createElement('style');
		sheetHideSubtitlesSettings.id = 'sheetHideSubtitlesSettings';
		sheetHideSubtitlesSettings.innerHTML = '.gobrain-subtitles-menu{display: none !important;}';
		document.head.appendChild(sheetHideSubtitlesSettings);
	}

	if (!settings?.bottomControls?.showAudioTracksSettings && !document.getElementById('sheetHideAudioTracksSettings')) {
		var sheetHideAudioTracksSettings = document.createElement('style');
		sheetHideAudioTracksSettings.id = 'sheetHideAudioTracksSettings';
		sheetHideAudioTracksSettings.innerHTML = '.gobrain-audio-menu{display: none !important;}';
		document.head.appendChild(sheetHideAudioTracksSettings);
	}

	if (settings?.topControls && !settings?.topControls?.enabled && !document.getElementById('sheetHideTopControls')) {
		var sheetHideTopControls = document.createElement('style');
		sheetHideTopControls.id = 'sheetHideTopControls';
		sheetHideTopControls.innerHTML = '.gobrain-topcontrolbar-wrapper{display: none !important;}';
		document.head.appendChild(sheetHideTopControls);
	}

	if (settings?.topControls && !settings?.topControls?.showTitle && !document.getElementById('sheetHideTopControlsTitle')) {
		var sheetHideTopControlsTitle = document.createElement('style');
		sheetHideTopControlsTitle.id = 'sheetHideTopControlsTitle';
		sheetHideTopControlsTitle.innerHTML = '.gobrain-playback-title{display: none !important;}';
		document.head.appendChild(sheetHideTopControlsTitle);
	}

	if (settings?.topControls && !settings?.topControls?.showAccountName && !document.getElementById('sheetHideTopControlsAccountName')) {
		var sheetHideTopControlsAccountName = document.createElement('style');
		sheetHideTopControlsAccountName.id = 'sheetHideTopControlsAccountName';
		sheetHideTopControlsAccountName.innerHTML = '.gobrain-playlist-title{display: none !important;}';
		document.head.appendChild(sheetHideTopControlsAccountName);
	}

	if (!document.getElementById('sheetHideTopCotrolsSocialSharing')) {
		var sheetHideTopCotrolsSocialSharing = document.createElement('style');
		if (paramSharing === null) {
			if (settings.topControls && !settings?.topControls?.showSocialSharing) {
				sheetHideTopCotrolsSocialSharing.id = 'sheetHideTopCotrolsSocialSharing';
				sheetHideTopCotrolsSocialSharing.innerHTML = '.gobrain-fn-sharing{display: none !important;}';
				document.head.appendChild(sheetHideTopCotrolsSocialSharing);
			}
		} else {
			if (paramSharing === 'false') {
				sheetHideTopCotrolsSocialSharing.id = 'sheetHideTopCotrolsSocialSharing';
				sheetHideTopCotrolsSocialSharing.innerHTML = '.gobrain-fn-sharing{display: none !important;}';
				document.head.appendChild(sheetHideTopCotrolsSocialSharing);
			}
		}
	}

	if (settings?.topControls && settings?.topControls?.alwaysVisible && !document.getElementById('sheetAlwaysVisibleTopControls')) {
		var sheetAlwaysVisibleTopControls = document.createElement('style');
		sheetAlwaysVisibleTopControls.id = 'sheetAlwaysVisibleTopControls';
		sheetAlwaysVisibleTopControls.innerHTML = '.gobrain-topcontrolbar-wrapper{opacity: 1 !important;}';
		document.head.appendChild(sheetAlwaysVisibleTopControls);
	}

	if (!document.getElementById('sheetHideTopControlsDownload')) {
		var sheetHideTopControlsDownload = document.createElement('style');
		if (paramDownload === null) {
			if (settings?.topControls && !settings.topControls?.showDownloadButton) {
				sheetHideTopControlsDownload.id = 'sheetHideTopControlsDownload';
				sheetHideTopControlsDownload.innerHTML = '.gobrain-fn-download-video{display: none !important;}';
				document.head.appendChild(sheetHideTopControlsDownload);
			}
		} else {
			if (paramDownload === 'false') {
				sheetHideTopControlsDownload.id = 'sheetHideTopControlsDownload';
				sheetHideTopControlsDownload.innerHTML = '.gobrain-fn-download-video{display: none !important;}';
				document.head.appendChild(sheetHideTopControlsDownload);
			}
		}
	}

	if (settings?.playerStyling && settings?.playerStyling?.playerFont && !document.getElementById('sheetPlayerFontPlayerStyling')) {
		var sheetPlayerFontPlayerStyling = document.createElement('style');
		sheetPlayerFontPlayerStyling.id = 'sheetPlayerFontPlayerStyling';
		let fontStyling = '';

		let fontName = '';
		let subtitleLineHeight = '1.25';
		if (settings.playerStyling.useCustomFont) {
			subtitleLineHeight = fontName.includes('Poppins') || fontName.includes('Open Sans') ? '1.7em' : subtitleLineHeight;
			fontStyling += `@import url('${settings.playerStyling.playerCustomFontUrl}');`;
			fontStyling += `body,div, *{font-family: ${settings.playerStyling.playerCustomFontName ?? "'Poppins', sans-serif"};}`;
		} else {
			fontName = settings.playerStyling.playerFont !== '' ? settings.playerStyling.playerFont : 'Poppins';
			let semiBoldFont = '';
			let lightFont = '';

			if (FONTS.includes(fontName)) {
				fontName += ', sans-serif';
			}
			if (fontName === 'Open Sans') {
				fontName = `'Open Sans Regular', sans-serif`;
				semiBoldFont = `.qplayer-semibold-font{font-family: 'Open Sans Semibold', sans-serif !important; font-weight: normal !important;}`;
				lightFont = `.qplayer-light-font{font-family: 'Open Sans Light' !important; font-weight: normal !important;}`;
			}
			fontStyling = `body,div, *{font-family: ${fontName};}${lightFont}${semiBoldFont}`;
			subtitleLineHeight = fontName.includes('Poppins') ? '1.7em' : subtitleLineHeight;
		}
		const subtitleTextStyle = `.gobrain-id-subtitles-container .subtitle-text span{line-height:${subtitleLineHeight} !important;}`;

		sheetPlayerFontPlayerStyling.innerHTML = fontStyling + subtitleTextStyle;
		document.head.appendChild(sheetPlayerFontPlayerStyling);
	}

	if (settings?.playerStyling && settings?.playerStyling?.primaryColor) {
		const color = settings?.playerStyling?.primaryColor ?? '#126cfc';
		const opacity = Number(settings?.playerStyling?.primaryOpacity ?? 100);
		const rgbaWithOpa = { ...tinycolor(color).toRgb(), a: opacity / 100 };

		if (!document.getElementById('sheetHoverColorPlayerStyling')) {
			const sheetHoverColorPlayerStyling = document.createElement('style');
			sheetHoverColorPlayerStyling.id = 'sheetHoverColorPlayerStyling';
			sheetHoverColorPlayerStyling.innerHTML = `.gobrain-hovering{background-color: ${tinycolor(rgbaWithOpa).toRgbString()} !important;}
														.gobrain-id-controls-container .gobrain-window .gobrain-additional-settings-main-menu{background-color: ${tinycolor(
															rgbaWithOpa
														).toRgbString()} !important;}
														.gobrain-id-controls-container .gobrain-option-row[aria-checked='true']{background-color: ${tinycolor(rgbaWithOpa).toRgbString()} !important;}
														.gobrain-id-controls-container .gobrain-option-row:hover:not(.gobrain-window-header){background-color: ${tinycolor(
															rgbaWithOpa
														).toRgbString()} !important;}
														.gobrain-reset-styling input[type="radio"]:checked+.radio-label:before{box-shadow: inset 0 0 0 2.5px ${tinycolor(
															rgbaWithOpa
														).toRgbString()} !important;}`;
			document.head.appendChild(sheetHoverColorPlayerStyling);
		}
	}
};

export const enterFullscreen = (currentPlayerId, callback) => {
	if (isIOS || (isMacOs && 'ontouchend' in document)) {
		const widget = window.GoBrain.widgets()[currentPlayerId];
		widget?.fullscreen && widget.fullscreen();
	} else {
		let elem = document.documentElement;
		if (!elem) {
			elem = document.getElementById('main-container');
		}
		elem?.requestFullscreen?.();
		callback?.();
	}
};

export const exitFullscreen = (currentPlayerId, callback) => {
	if (isIOS || (isMacOs && 'ontouchend' in document)) {
		const widget = window.GoBrain.widgets()[currentPlayerId];
		widget?.fullscreen(false);
	} else {
		document.exitFullscreen?.();
		callback?.();
	}
};
export const SHARE_ORIGIN_ITEMS = {
	directLink: 'directLink',
	siteEmbed: 'siteEmbed',
	custom: 'custom',
};
export const getPreviewLink = ({ configs, accountId, type, paramConfigs, mediaDetails, time, embedShareSettings }) => {
	if (!configs) {
		return 'No settings found';
	}
	if (!mediaDetails) {
		return 'No media found';
	}

	let timeParam = '';
	if (time) {
		timeParam = `id=${mediaDetails.id}&in=${time}`;
	}

	const shareSettings = configs.topControls?.shareSettings ?? {};
	if (embedShareSettings?.shareUrl) {
		return `${embedShareSettings.shareUrl}${timeParam ? '?' + timeParam : ''}`;
	}

	if (shareSettings.urlOrigin && shareSettings.urlOrigin !== SHARE_ORIGIN_ITEMS.directLink) {
		const urlOrigin = shareSettings.urlOrigin === SHARE_ORIGIN_ITEMS.siteEmbed ? embedShareSettings.origin : shareSettings.customUrl;
		return `${urlOrigin ?? qplayerDomain}${timeParam ? '?' + timeParam : ''}`;
	}

	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, language } = configs;
	const mediaType = type === 'video' ? 'mediaId' : type === 'scenario' ? 'scenarioId' : 'playlistId';
	const muteAtStartAttr = paramConfigs && muteAtStart !== paramConfigs.mute ? `&mute=${paramConfigs.mute}` : '';
	const autostartAttr = paramConfigs && autostart !== paramConfigs.autoplay ? `&autoplay=${paramConfigs.autoplay}` : '';
	const showSocialSharingAttr = paramConfigs && showSocialSharing !== paramConfigs.sharing ? `&sharing=${paramConfigs.sharing}` : '';
	const replayAttr = paramConfigs && replay !== paramConfigs.repeat ? `&repeat=${paramConfigs.repeat}` : '';
	const showDownloadButtonAttr =
		paramConfigs && showDownloadButton !== paramConfigs.downloadMedia ? `&downloadMedia=${paramConfigs.downloadMedia}` : '';
	const languageAttr = paramConfigs && language !== paramConfigs.language && language ? `&language="${language}"` : '';

	return `${qplayerDomain}?accountId=${accountId}&${mediaType}=${mediaDetails.id}&configId=${configs.id}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${replayAttr}${muteAtStartAttr}${languageAttr}${timeParam ? '&' + timeParam : ''}`;
};

export const getIframeEmbedCode = ({ configs, accountId, type, mediaDetails, paramConfigs, time }) => {
	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, language } = configs;
	if (!configs) {
		return 'No player configs found';
	}
	if (!mediaDetails) {
		return 'No media found';
	}

	let timeParam = '';
	if (time) {
		timeParam = `&id=${mediaDetails.id}&in=${time}`;
	}

	const title = mediaDetails?.title;
	const mediaType = type === 'video' ? 'mediaId' : type === 'scenario' ? 'scenarioId' : 'playlistId';
	const muteAtStartAttr = paramConfigs && muteAtStart !== paramConfigs.mute ? `&mute=${paramConfigs.mute}` : '';
	const autostartAttr = paramConfigs && autostart !== paramConfigs.autoplay ? `&autoplay=${paramConfigs.autoplay}` : '';
	const showSocialSharingAttr = paramConfigs && showSocialSharing !== paramConfigs.sharing ? `&sharing=${paramConfigs.sharing}` : '';
	const replayAttr = paramConfigs && replay !== paramConfigs.repeat ? `&repeat=${paramConfigs.repeat}` : '';
	const showDownloadButtonAttr =
		paramConfigs && showDownloadButton !== paramConfigs.downloadMedia ? `&downloadMedia=${paramConfigs.downloadMedia}` : '';
	const languageAttr = paramConfigs && language !== paramConfigs.language && language ? `&language="${language}"` : '';
	const allow = autostartAttr && muteAtStart ? 'autoplay; ' : '';

	return `<iframe height="360" width="640" title="${title}" src="${qplayerDomain}?accountId=${accountId}&${mediaType}=${mediaDetails.id}&configId=${configs.id}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${replayAttr}${muteAtStartAttr}${languageAttr}${timeParam}" allow="${allow}picture-in-picture; clipboard-write; web-share" allowFullScreen frameborder="0" border="0"></iframe>`;
};

export const getDivEmbedCode = ({ configs, accountId, type, mediaDetails, paramConfigs, time }) => {
	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, showOpenInNewWindow, language } = configs;

	const title = mediaDetails?.title;
	const muteAtStartAttr = paramConfigs && muteAtStart !== paramConfigs.muteAtStart ? `data-qplayer-mute="${muteAtStart}" ` : '';
	const autostartAttr = paramConfigs && autostart !== paramConfigs.autostart ? `data-qplayer-autoplay="${autostart}" ` : '';
	const showSocialSharingAttr =
		paramConfigs && showSocialSharing !== paramConfigs.showSocialSharing ? `data-qplayer-sharing="${showSocialSharing}" ` : '';
	const replayAttr = paramConfigs && replay !== paramConfigs.replay ? `data-qplayer-repeat="${replay}" ` : '';
	const showDownloadButtonAttr =
		paramConfigs && showDownloadButton !== paramConfigs.showDownloadButton ? `data-qplayer-download="${showDownloadButton}" ` : '';
	const showOpenInNewWindowAttr =
		paramConfigs && showOpenInNewWindow !== paramConfigs.showOpenInNewWindow ? `data-qplayer-openInNewWindow="${showOpenInNewWindow}" ` : '';
	const mediaType = type === 'video' ? 'media' : type === 'scenario' ? 'scenario' : 'playlist';
	const languageAttr = paramConfigs && language !== paramConfigs.language && language ? `data-qplayer-language="${language}"` : '';
	const timeAttr = time ? `data-qplayer-startAt="${time}"` : '';

	const isDevEnv = process.env.NODE_ENV !== 'production';

	// video ratio 16:9, set padding-bottom 56.25%; video ratio 1:1, set padding-bottom 100%
	return (
		`<div style="position:relative;padding-bottom:56.25%;">` +
		`<div style="position:absolute;top:0;left:0;" ` +
		`title="${title}" ` +
		`data-qplayer-account-id="${accountId}" ` +
		`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
		`data-qplayer-preset-id="${configs.id}" ` +
		`${isDevEnv ? 'data-qplayer-test="true" ' : ''}` +
		`${timeAttr}` +
		`${languageAttr}` +
		`${autostartAttr}` +
		`${showSocialSharingAttr}` +
		`${muteAtStartAttr}` +
		`${replayAttr}` +
		`${showDownloadButtonAttr}` +
		`${showOpenInNewWindowAttr}></div>\n` +
		`<script id="qplayer" src="${qplayerLoaderUrl}"></script>` +
		`</div>`
	);
};

export const formatTime = (time) => {
	if (!time || isNaN(+time) || !isFinite(+time) || 0.5 > Math.abs(time)) {
		return '00:00:00';
	}

	var hours = Math.floor(time / 3600),
		minutes = Math.floor(time / 60) % 60,
		seconds = Math.floor(time % 60);

	var formattedTime = '';

	formattedTime += (hours < 10 ? '0' : '') + hours + ':';

	return formattedTime + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const parseTime = (value) => {
	var datetime = new Date('1970-01-01T' + value + 'Z');
	var hours = datetime.getUTCHours();
	var minutes = datetime.getUTCMinutes();
	var seconds = datetime.getUTCSeconds();

	return hours * 3600 + minutes * 60 + seconds;
};

export const stringFormat = (pattern, options) => {
	if (!pattern) {
		return null;
	}

	var _args = Object.keys(options);
	for (var i = 1; i < _args.length; i++) {
		pattern = pattern.replace(new RegExp('\\{' + (i - 1) + '\\}', 'g'), _args[i]);
	}

	return pattern;
};

export const generateUUID = () => {
	let d = new Date().getTime();
	if (Date.now) {
		d = Date.now();
	}

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		let r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});
};

export const getTranslateKey = (originKey) => {
	let translationKey = originKey;
	if (originKey.includes('-cc') || originKey.includes('-ad')) {
		translationKey = originKey.split('-')[0];
	}
	return translationKey;
};

export const checkPreCoverActive = (coverTracks) => {
	if (!coverTracks) {
		return false;
	}

	if (coverTracks.length && coverTracks[0] && coverTracks[0].sequences && coverTracks[0].sequences.length) {
		const preCover =
			coverTracks[0].sequences.filter((sequence) => {
				return 0 === sequence.start && (undefined === sequence.end || 0 < sequence.end);
			})[0] || null;

		return !!preCover;
	}

	return false;
};

export const checkPostCoverActive = (coverTracks, liveManager) => {
	if (!coverTracks || !liveManager) {
		return false;
	}

	const { start, stop } = liveManager;

	const dateNowUtcTimestamp = Date.now();
	const eventStartDate = new Date(start);

	if (stop) {
		const eventEndDate = new Date(stop);
		const eventEndDateUtcTimestamp = eventEndDate.getTime();

		if (dateNowUtcTimestamp > eventEndDateUtcTimestamp) {
			return true; // means there is postcover - default or custom
		}
	}

	if (coverTracks.length && coverTracks[0] && coverTracks[0].sequences && coverTracks[0].sequences.length) {
		const postCover =
			coverTracks[0].sequences.filter((sequence) => {
				return 0 < sequence.start && undefined === sequence.end;
			})[0] || null;

		if (postCover) {
			const eventStartDateUtcTimestamp = eventStartDate.getTime();
			const finishDateUtcTimestamp = eventStartDateUtcTimestamp + postCover.start * 1000;

			if (dateNowUtcTimestamp > finishDateUtcTimestamp) {
				return !!postCover;
			}
		}
	}

	return false;
};

export const convertSecondsToInputTime = (time) => {
	if (isNaN(+time) || !isFinite(+time) || 0.5 > Math.abs(time)) {
		return '00:00:00';
	}

	const hours = Math.floor(time / 3600),
		minutes = Math.floor(time / 60) % 60,
		seconds = Math.floor(time % 60);

	let formattedTime = '';
	formattedTime += (hours < 10 ? '0' : '') + hours + ':';

	return formattedTime + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const formatInputTime = (input) => {
	let timeArray = input.split(':');
	if (timeArray.length === 3) {
		return input;
	}
	if (timeArray.length === 2) {
		return `00:${timeArray[0]}:${timeArray[1]}`;
	}
	return '00:00:00';
};

export const convertInputTimeToSeconds = (value) => {
	if (!isNaN(+value)) {
		return value;
	}

	const dateTime = new Date('1970-01-01T' + formatInputTime((value ?? '00:00:00').replace('.', ':')) + 'Z');
	const hours = dateTime.getUTCHours();
	const minutes = dateTime.getUTCMinutes();
	const seconds = dateTime.getUTCSeconds();

	return hours * 3600 + minutes * 60 + seconds;
};

export const isAllowAutoPlay = ({ queryParams, settings }) => {
	const autoplayFromParam = !queryParams?.autoplay ? (settings?.playbackOptions?.autostart ? true : false) : queryParams?.autoplay === 'true';
	const volume = !queryParams?.mute ? (settings?.playbackOptions?.muteAtStart ? 0 : 0.5) : queryParams?.mute === 'true' ? 0 : 0.5;

	return autoplayFromParam && volume === 0;
};

export const isUsedOnMobile = (queryParams) => {
	if (queryParams?.mobileDevice) {
		return queryParams?.mobileDevice === 'true';
	}

	return isMobile && !isTablet;
};

export const isTouchable = () => {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || isMobile;
};

export const getSubtitleFontSizeInPixelBasedOnScreenSize = (isMobile) => {
	const screenSize = window.innerWidth;
	if (isMobile || screenSize <= 430) {
		return 14;
	} else if (screenSize <= 600) {
		return 14;
	} else if (screenSize <= 768) {
		return 16;
	} else if (screenSize <= 1280) {
		return 24;
	} else {
		return 40;
	}
};

export const focusOnFirstElement = () => {
	setTimeout(() => {
		let currentActiveElement = document.querySelector('.closeable-by-tab');

		if (currentActiveElement) {
			if (currentActiveElement.querySelector('.menu-item--hovered[tabindex="0"]')) {
				currentActiveElement.querySelector('.menu-item--hovered[tabindex="0"]')?.focus();
			} else {
				currentActiveElement.querySelector('li[tabindex="0"], button[tabindex="0"]')?.focus();
			}
		}
	}, 50);
};
